module.exports = __webpack_public_path__ + "img/1.5f620d9b.jpg";